import { NailArtCard } from '@we-make-websites/ui-lib/src';
import type { NailArtCardProps, ImageType } from '@we-make-websites/ui-lib/src';
import {
  Shimmer,
  toBase64,
} from '@we-make-websites/ui-lib/src/components/utility/imageShimmer/ImageShimmer';
import type { BaseHit } from 'instantsearch.js';
import styles from 'components/InstantSearchList/InstantSearchList.module.scss';
import { WishlistButtonConnected } from '../wishlistButton/WishlistButtonConnected';

export type AlgoliaNailArtHit = BaseHit & {
  title: string;
  handle: string;
  newTab: boolean;
  images?: ImageType[];
  description?: string;
  author?: string;
  proOnly?: boolean;
  urlCategory?: string;
};

export const NailArtCardHit = ({ hit }: { hit: AlgoliaNailArtHit }) => {
  const {
    title,
    handle,
    images,
    description,
    author,
    proOnly,
    newTab,
    urlCategory,
  } = hit;

  const urlDirectory =
    urlCategory === 'professionals' ? 'professionals' : 'nail-art';

  const url = handle ? `/${urlDirectory}/${handle}` : '';

  let image = `data:image/svg+xml;base64,${toBase64(Shimmer(280, 333))}`;
  if (images && images?.length > 0 && images[0]?.url) {
    image = images[0].url;
  }

  const props: NailArtCardProps = {
    title,
    description: description ?? '',
    url,
    newTab,
    author,
    image,
    imageTitle: images?.[0]?.title ?? '',
    isLoading: false,
    proOnly: Boolean(proOnly),
    wishlistComponent: WishlistButtonConnected,
  };

  return (
    <article
      className={styles.searchContent__gridItemContent}
      data-test-id="nailArtCard"
    >
      <NailArtCard {...props} />
    </article>
  );
};
